import { IS_TEST, ENVIRONMENT } from '@updater-core/lib/environment';
import Raven from 'raven-js';
import session from '@updater-core/interactors/shell/session';

const { url: API_URL, version } = ENVIRONMENT.endpoints.api;
const RESPONSES_TO_IGNORE = [
  {
    httpResponseStatus: 404,
    apiRequestEndpoint: `${API_URL}/${version}/users/emails`,
  },
  {
    httpResponseStatus: 418,
    apiRequestEndpoint: `${API_URL}/${version}/sessions`,
    pathname: '/sign-in',
  },
  {
    httpResponseStatus: 401,
    apiRequestEndpoint: `${API_URL}/${version}/sessions`,
    pathname: '/sign-in',
  },
];

function shouldIgnoreResponse(data) {
  return (ignore) =>
    Object.keys(ignore).every((key) => data.tags[key] === ignore[key]);
}

export function buildSentry() {
  // Don't log errors while testing or if Raven Integration is disabled
  if (
    !IS_TEST &&
    !ENVIRONMENT?.integrations?.disableRaven &&
    typeof window !== 'undefined'
  ) {
    window.Raven = Raven;
    Raven.config(ENVIRONMENT.keys.sentry, {
      environment: ENVIRONMENT.name,
      maxMessageLength: 1000,
      release: __COMMIT_HASH__,
      shouldSendCallback: (data) => {
        if (!data || !data.tags) {
          return true;
        }

        // These errors are expected in regular use; don't even send these to Sentry
        return !RESPONSES_TO_IGNORE.some(shouldIgnoreResponse(data));
      },
    }).install();
    window.addEventListener('unhandledrejection', (rejection) =>
      rejection.reason
        ? Raven.captureException(rejection.reason)
        : Raven.captureMessage(
            `unhandled promise rejection that doesnt have a reason: ${rejection}`
          )
    );

    session.connect((sessionState) => {
      if (session.selectors.isAuthenticated(sessionState)) {
        Raven.setUserContext({
          uuid: session.selectors.uuid(sessionState),
          email: session.selectors.userEmail(sessionState),
        });
      } else {
        Raven.setUserContext();
      }
    });
  }
}
